import type { InjectionKey } from 'vue';
import type { InjectionValue } from '@tools/types';
import type { VInfoBoxProps } from './VInfoBox.vue';

export const typeInjectionKey = Symbol('type') as InjectionKey<
  InjectionValue<VInfoBoxProps['type']>
>;
